import { render, staticRenderFns } from "./FollowPopup.vue?vue&type=template&id=b1199422&scoped=true&"
import script from "./FollowPopup.vue?vue&type=script&lang=js&"
export * from "./FollowPopup.vue?vue&type=script&lang=js&"
import style0 from "./FollowPopup.vue?vue&type=style&index=0&id=b1199422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1199422",
  null
  
)

export default component.exports